const tokens = require('./dist/js/tokens.legacy');
const tokens_next = require('./dist/js/tokens');
const meta = require('./dist/meta/meta');

module.exports = {
  tokens,
  tokens_legacy: tokens,
  tokens_next,
  meta,
};
